/* src/components/GreenEnergy/GreenEnergy.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	add_flush_callback,
	append_hydration,
	attr,
	bind,
	binding_callbacks,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert_hydration,
	mount_component,
	noop,
	safe_not_equal,
	set_data,
	set_style,
	space,
	src_url_equal,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import Icon from '../Icon/Icon.svelte';
import getGrade9 from '../../helpers/svelte/utils/getGrade9';

import {
	formatPercent,
	strongNumbers,
	outputFirstItem
} from '../../helpers/svelte/utils/formatters';

import EmbedModal from '../EmbedModal/EmbedModal.svelte';
import { onMount } from 'svelte';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[13] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[16] = list[i];
	child_ctx[18] = i;
	return child_ctx;
}

// (121:0) {#if embedDetector}
function create_if_block_3(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { id: true });
			children(div).forEach(detach);
			this.h();
		},
		h() {
			attr(div, "id", /*embedDetector*/ ctx[2]);
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*embedDetector*/ 4) {
				attr(div, "id", /*embedDetector*/ ctx[2]);
			}
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (133:10) {#if fuel.is_renewable}
function create_if_block_2(ctx) {
	let icon;
	let current;
	icon = new Icon({ props: { icon: "refresh" } });

	return {
		c() {
			create_component(icon.$$.fragment);
		},
		l(nodes) {
			claim_component(icon.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(icon, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icon, detaching);
		}
	};
}

// (153:12) {:else}
function create_else_block(ctx) {
	let span;
	let t;

	return {
		c() {
			span = element("span");
			t = text("❓");
			this.h();
		},
		l(nodes) {
			span = claim_element(nodes, "SPAN", {
				style: true,
				role: true,
				"aria-label": true
			});

			var span_nodes = children(span);
			t = claim_text(span_nodes, "❓");
			span_nodes.forEach(detach);
			this.h();
		},
		h() {
			set_style(span, "padding", "1px 9px");
			set_style(span, "font-size", "2rem");
			attr(span, "role", "img");
			attr(span, "aria-label", "other fuel");
		},
		m(target, anchor) {
			insert_hydration(target, span, anchor);
			append_hydration(span, t);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (139:12) {#if FUEL_ICONS[fuel.fuel_category]}
function create_if_block_1(ctx) {
	let div;
	let img;
	let img_src_value;
	let img_alt_value;
	let t;

	return {
		c() {
			div = element("div");
			img = element("img");
			t = space();
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true, style: true });
			var div_nodes = children(div);

			img = claim_element(div_nodes, "IMG", {
				width: true,
				height: true,
				src: true,
				alt: true
			});

			t = claim_space(div_nodes);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(img, "width", "50px");
			attr(img, "height", "50px");
			if (!src_url_equal(img.src, img_src_value = `/site-images/${/*FUEL_ICONS*/ ctx[5][/*fuel*/ ctx[13].fuel_category]}`)) attr(img, "src", img_src_value);
			attr(img, "alt", img_alt_value = /*fuel*/ ctx[13].fuel_category);
			attr(div, "class", "fuel-rating-icon svelte-1fbgxni");
			set_style(div, "overflow", "hidden");

			set_style(div, "width", (Math.ceil(/*fuel*/ ctx[13].production_fraction_of_total * 100 / 10) === /*i*/ ctx[18] + 1
			? /*fuel*/ ctx[13].production_fraction_of_total % 0.1 * 500
			: 50) + "px");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			append_hydration(div, img);
			append_hydration(div, t);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (138:10) {#each { length: Math.ceil((fuel.production_fraction_of_total * 100) / 10) || 1 } as _, i}
function create_each_block_1(ctx) {
	let if_block_anchor;

	function select_block_type(ctx, dirty) {
		if (/*FUEL_ICONS*/ ctx[5][/*fuel*/ ctx[13].fuel_category]) return create_if_block_1;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_block.m(target, anchor);
			insert_hydration(target, if_block_anchor, anchor);
		},
		p(ctx, dirty) {
			if_block.p(ctx, dirty);
		},
		d(detaching) {
			if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (129:4) {#each shownFuels as fuel}
function create_each_block(ctx) {
	let div3;
	let div0;
	let t0_value = /*fuel*/ ctx[13].fuel_category.toUpperCase() + "";
	let t0;
	let t1;
	let t2;
	let div1;
	let t3;
	let div2;

	let t4_value = (/*fuel*/ ctx[13].production_fraction_of_total > 0
	? formatPercent(/*fuel*/ ctx[13].production_fraction_of_total, 2)
	: `-${formatPercent(/*fuel*/ ctx[13].production_fraction_of_total, 2)}`) + "";

	let t4;
	let t5;
	let current;
	let if_block = /*fuel*/ ctx[13].is_renewable && create_if_block_2(ctx);

	let each_value_1 = {
		length: Math.ceil(/*fuel*/ ctx[13].production_fraction_of_total * 100 / 10) || 1
	};

	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	return {
		c() {
			div3 = element("div");
			div0 = element("div");
			t0 = text(t0_value);
			t1 = space();
			if (if_block) if_block.c();
			t2 = space();
			div1 = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t3 = space();
			div2 = element("div");
			t4 = text(t4_value);
			t5 = space();
			this.h();
		},
		l(nodes) {
			div3 = claim_element(nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			div0 = claim_element(div3_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			t0 = claim_text(div0_nodes, t0_value);
			t1 = claim_space(div0_nodes);
			if (if_block) if_block.l(div0_nodes);
			div0_nodes.forEach(detach);
			t2 = claim_space(div3_nodes);
			div1 = claim_element(div3_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(div1_nodes);
			}

			div1_nodes.forEach(detach);
			t3 = claim_space(div3_nodes);
			div2 = claim_element(div3_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			t4 = claim_text(div2_nodes, t4_value);
			div2_nodes.forEach(detach);
			t5 = claim_space(div3_nodes);
			div3_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div0, "class", "fuel-type svelte-1fbgxni");
			attr(div1, "class", "fuel-rating-count svelte-1fbgxni");
			attr(div2, "class", "fuel-percentage svelte-1fbgxni");
			attr(div3, "class", "fuel-types-list-item svelte-1fbgxni");
		},
		m(target, anchor) {
			insert_hydration(target, div3, anchor);
			append_hydration(div3, div0);
			append_hydration(div0, t0);
			append_hydration(div0, t1);
			if (if_block) if_block.m(div0, null);
			append_hydration(div3, t2);
			append_hydration(div3, div1);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div1, null);
			}

			append_hydration(div3, t3);
			append_hydration(div3, div2);
			append_hydration(div2, t4);
			append_hydration(div3, t5);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*Math, shownFuels, FUEL_ICONS*/ 96) {
				each_value_1 = {
					length: Math.ceil(/*fuel*/ ctx[13].production_fraction_of_total * 100 / 10) || 1
				};

				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div1, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value_1.length;
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div3);
			if (if_block) if_block.d();
			destroy_each(each_blocks, detaching);
		}
	};
}

// (164:2) {#if componentEmbedId || debugEmbedId}
function create_if_block(ctx) {
	let div;
	let embedmodal;
	let updating_isModalOpen;
	let current;

	function embedmodal_isModalOpen_binding(value) {
		/*embedmodal_isModalOpen_binding*/ ctx[8](value);
	}

	let embedmodal_props = {
		previewMaxWidth: "600px",
		componentEmbedId: /*componentEmbedId*/ ctx[0] || debugEmbedId,
		embedOrigin: /*embedOrigin*/ ctx[3]
	};

	if (/*isModalOpen*/ ctx[4] !== void 0) {
		embedmodal_props.isModalOpen = /*isModalOpen*/ ctx[4];
	}

	embedmodal = new EmbedModal({ props: embedmodal_props });
	binding_callbacks.push(() => bind(embedmodal, 'isModalOpen', embedmodal_isModalOpen_binding));

	return {
		c() {
			div = element("div");
			create_component(embedmodal.$$.fragment);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			claim_component(embedmodal.$$.fragment, div_nodes);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "embed-button");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			mount_component(embedmodal, div, null);
			current = true;
		},
		p(ctx, dirty) {
			const embedmodal_changes = {};
			if (dirty & /*componentEmbedId*/ 1) embedmodal_changes.componentEmbedId = /*componentEmbedId*/ ctx[0] || debugEmbedId;
			if (dirty & /*embedOrigin*/ 8) embedmodal_changes.embedOrigin = /*embedOrigin*/ ctx[3];

			if (!updating_isModalOpen && dirty & /*isModalOpen*/ 16) {
				updating_isModalOpen = true;
				embedmodal_changes.isModalOpen = /*isModalOpen*/ ctx[4];
				add_flush_callback(() => updating_isModalOpen = false);
			}

			embedmodal.$set(embedmodal_changes);
		},
		i(local) {
			if (current) return;
			transition_in(embedmodal.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(embedmodal.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(embedmodal);
		}
	};
}

function create_fragment(ctx) {
	let t0;
	let section;
	let h2;
	let t1;
	let t2;
	let t3;
	let div;
	let t4;
	let current;
	let if_block0 = /*embedDetector*/ ctx[2] && create_if_block_3(ctx);
	let each_value = /*shownFuels*/ ctx[6];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	let if_block1 = (/*componentEmbedId*/ ctx[0] || debugEmbedId) && create_if_block(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t0 = space();
			section = element("section");
			h2 = element("h2");
			t1 = text(/*name*/ ctx[1]);
			t2 = text(" Production Fuel Makeup");
			t3 = space();
			div = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t4 = space();
			if (if_block1) if_block1.c();
			this.h();
		},
		l(nodes) {
			if (if_block0) if_block0.l(nodes);
			t0 = claim_space(nodes);
			section = claim_element(nodes, "SECTION", { id: true, class: true });
			var section_nodes = children(section);
			h2 = claim_element(section_nodes, "H2", { class: true });
			var h2_nodes = children(h2);
			t1 = claim_text(h2_nodes, /*name*/ ctx[1]);
			t2 = claim_text(h2_nodes, " Production Fuel Makeup");
			h2_nodes.forEach(detach);
			t3 = claim_space(section_nodes);
			div = claim_element(section_nodes, "DIV", { class: true });
			var div_nodes = children(div);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(div_nodes);
			}

			div_nodes.forEach(detach);
			t4 = claim_space(section_nodes);
			if (if_block1) if_block1.l(section_nodes);
			section_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(h2, "class", "heading-sm svelte-1fbgxni");
			attr(div, "class", "fuel-types-list svelte-1fbgxni");
			attr(section, "id", "fuel-types");
			attr(section, "class", "fuel-types");
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert_hydration(target, t0, anchor);
			insert_hydration(target, section, anchor);
			append_hydration(section, h2);
			append_hydration(h2, t1);
			append_hydration(h2, t2);
			append_hydration(section, t3);
			append_hydration(section, div);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div, null);
			}

			append_hydration(section, t4);
			if (if_block1) if_block1.m(section, null);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*embedDetector*/ ctx[2]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_3(ctx);
					if_block0.c();
					if_block0.m(t0.parentNode, t0);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (!current || dirty & /*name*/ 2) set_data(t1, /*name*/ ctx[1]);

			if (dirty & /*shownFuels, formatPercent, Math, FUEL_ICONS*/ 96) {
				each_value = /*shownFuels*/ ctx[6];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(div, null);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}

			if (/*componentEmbedId*/ ctx[0] || debugEmbedId) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty & /*componentEmbedId*/ 1) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(section, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			transition_in(if_block1);
			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t0);
			if (detaching) detach(section);
			destroy_each(each_blocks, detaching);
			if (if_block1) if_block1.d();
		}
	};
}

let debugEmbedId = '';

function instance($$self, $$props, $$invalidate) {
	let { fuels } = $$props;
	let { name } = $$props;
	let { embedDetector } = $$props;
	let { embedOrigin } = $$props;
	let { componentEmbedId } = $$props;
	let isModalOpen = false;

	onMount(() => {
		if (!embedDetector) {
			console.warn('No embed detector provided');
			return;
		}

		const component = document.getElementById(embedDetector);

		if (!component) {
			console.warn('No component found with the provided embed detector ID:', embedDetector);
			return;
		}

		const embedDetectorDivParent = component.parentElement;

		if (!embedDetectorDivParent) {
			console.warn('No parent element found for the embed detector');
			return;
		}

		const embedId = embedDetectorDivParent.getAttribute('data-embed-id');

		if (!embedId) {
			console.warn('No embed ID found on the component');
			return;
		}

		$$invalidate(0, componentEmbedId = embedId);
	});

	const FUEL_ICONS = {
		Coal: 'coal.svg',
		Nuclear: 'nuclear.svg',
		Solar: 'solar.svg',
		Wind: 'windmill.svg',
		Other: 'others.svg',
		Kerosene: 'kerosene.svg',
		Geothermal: 'geothermal.svg',
		'Jet Fuel': 'jet.svg',
		'Other Gas': 'natural_gas.svg',
		'Wood/Wood Waste Solids': 'biomass.svg',
		'Black Liquour': 'black_liquour.svg',
		'Other Gas': 'natural_gas.svg',
		'Waste Heat': 'flame.svg',
		'Gaseous Propane': 'propane.svg',
		'Natural Gas': 'natural_gas.svg',
		'Conventional Hydroelectric': 'hydro.svg',
		'Petroleum Coke': 'coal.svg',
		'Distillate Fuel Oil': 'oil.svg',
		'Waste/other Oil': 'oil.svg',
		'Other Biomass Gas': 'natural_gas.svg',
		'Other Biomass Solids': 'biomass.svg',
		'Landfill Gas': 'natural_gas.svg',
		'Blast Furnace Gas': 'flame.svg',
		'Tire-derived Fuels': 'tire.svg',
		'Residual Fuel Oil': 'oil.svg',
		'Non-biogenic Municipal Solid Waste': 'nonbiomsolidwaste.svg',
		'Biogenic Municipal Solid Waste': 'biogenicmsolidwaste.svg',
		'Purchased Steam': 'steam.svg',
		'Sludge Waste': 'sludge.svg',
		'Municipal Solid Waste': 'nonbiomsolidwaste.svg',
		'Wood Waste Liquids': 'bio_liquid.svg',
		'Batteries or other use of electricity as an energy source': 'battery.svg',
		'Agricultural By-products': 'agro.svg',
		'Other Biomass Liquids': 'bio_liquid.svg'
	};

	const filteredFuels = fuels
	? fuels.filter(f => f.fuel_category !== 'Renewable' && f.fuel_category !== 'Nonrenewable' && f.fuel_category !== 'All').sort((a, b) => b.production_fraction_of_total - a.production_fraction_of_total)
	: [];

	const shownFuels = filteredFuels.splice(0, 5);

	if (filteredFuels.length > 0) {
		const otherEntry = filteredFuels.reduce(
			(out, cv) => {
				out.production_fraction_of_total += cv.production_fraction_of_total;
				return out;
			},
			{
				fuel_category: 'Other',
				is_renewable: false,
				production_fraction_of_total: 0
			}
		);

		shownFuels.push(otherEntry);
	}

	const renewableFuels = fuels ? fuels.filter(f => f.is_renewable) : [];
	const mainRenewableFuel = renewableFuels ? renewableFuels[0] : null;
	let renewableFuelIcon = 'green.svg';

	if (mainRenewableFuel) {
		if (mainRenewableFuel.fuel_category === 'Solar') {
			renewableFuelIcon = 'solar.svg';
		} else if (mainRenewableFuel.fuel_category === 'Conventional Hydroelectric') {
			renewableFuelIcon = 'hydro.svg'; // need better icon
		} else if (mainRenewableFuel.fuel_category === 'Wind') {
			renewableFuelIcon = 'windmill.svg';
		} else if (mainRenewableFuel.fuel_category.toLowerCase().includes('wood')) {
			renewableFuelIcon = 'biomass.svg';
		}
	}

	function embedmodal_isModalOpen_binding(value) {
		isModalOpen = value;
		$$invalidate(4, isModalOpen);
	}

	$$self.$$set = $$props => {
		if ('fuels' in $$props) $$invalidate(7, fuels = $$props.fuels);
		if ('name' in $$props) $$invalidate(1, name = $$props.name);
		if ('embedDetector' in $$props) $$invalidate(2, embedDetector = $$props.embedDetector);
		if ('embedOrigin' in $$props) $$invalidate(3, embedOrigin = $$props.embedOrigin);
		if ('componentEmbedId' in $$props) $$invalidate(0, componentEmbedId = $$props.componentEmbedId);
	};

	return [
		componentEmbedId,
		name,
		embedDetector,
		embedOrigin,
		isModalOpen,
		FUEL_ICONS,
		shownFuels,
		fuels,
		embedmodal_isModalOpen_binding
	];
}

class GreenEnergy extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			fuels: 7,
			name: 1,
			embedDetector: 2,
			embedOrigin: 3,
			componentEmbedId: 0
		});
	}
}

export default GreenEnergy;